module.exports = __webpack_public_path__ + "img/smartlocal3.25c0333c.png";